import { render } from "./ZoomableAvatar.vue?vue&type=template&id=59553d67&scoped=true"
import script from "./ZoomableAvatar.vue?vue&type=script&lang=js"
export * from "./ZoomableAvatar.vue?vue&type=script&lang=js"

import "./ZoomableAvatar.vue?vue&type=style&index=0&id=59553d67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59553d67"]])

export default __exports__